module.exports = __webpack_public_path__ + "img/tando@2x.92cd6f0.png";